import { styled } from "@mui/material"
import { Banner } from "./Banner"

export const GradientBanner = styled(Banner)<{ display: string }>(
  ({ display }) => ({
    display,
    marginBottom: 0,
    padding: 0,
    position: "relative",
    zIndex: 1401,
    ".MuiPaper-root": {
      marginBottom: 0,
      padding: 10,
      width: "100%",
      height: "fit-content",
      alignItems: "center",
      background:
        "linear-gradient(270deg, #18345E 0%, transparent 100%), rgba(0, 0, 0, 1)",
      borderRadius: 0,
      ".MuiAlert-icon": {
        display: "none",
        margin: 0,
      },
      ".MuiAlert-message": {
        padding: 0,
      },
    },
  })
)
